import { NgModule } from '@angular/core';

import { LimitPipe } from './limit.shared.pipe';

const toExport: any[] = [
    LimitPipe
];

@NgModule({
    declarations: [
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
})
export class LimitPipeModule { }
